import ProviderPage from './components/ProviderPage';

const routes = [
  {
    path: '/provider',
    name: 'menu.provider',
    icon: 'usb-symbol',
    // customIcon: true,
    loginRequired: true,
    component: ProviderPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
